import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { CATEGORY_TYPE, PN_CATEGORY_GROUP } from '../../utils/Utils';
const DEFAULT_CATEGORY = {
  id: null,
  name: "",
  group: '',
  type: 'IN',
};

const CATEGORY_TYPE_OPTIONS = Object.keys(CATEGORY_TYPE).map((c) => ({
  label: CATEGORY_TYPE[c],
  value: c,
}));


const CATEGORY_GROUP_OPTIONS = Object.keys(PN_CATEGORY_GROUP).map((c) => ({
  label: PN_CATEGORY_GROUP[c],
  value: c,
}));

const listOnlyhaveTypeOut = [
  'COMPANY_FOR_DRIVER',
]

const PNCategoryManager = () => {
  const history = useHistory();

  const clearPagi = useRef();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [view, setView] = useState({
    edit: false,
    add: false,
    details: false,
    isDelete: false,
  });

  const { errors, register, handleSubmit, reset, getValues, control, watch, setValue } = useForm(
    {
      defaultValues: DEFAULT_CATEGORY,
    }
  );
  const group = watch('group');


  const [loading, setLoading] = useState(false);
  const [onSearchText, setSearchText] = useState("");
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [filter, setFilter] = useState({
    type: searchParams.get("type") || "IN",
    group: searchParams.get("group") || "DRIVER",
  });

  const routePath = '/pn-category';

  const colTable = [
    {
      Header: "Mã",
      accessor: "id",
    },
    {
      Header: "Tên danh mục",
      accessor: "name",
    },
    {
      Header: "Nhóm",
      accessor: (item) => PN_CATEGORY_GROUP[item.group],
    },
    {
      Header: "Loại",
      accessor: (item) => CATEGORY_TYPE[item.type],
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      type: filter.type,
      group: filter.group,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        group: filter.group,
        type: filter.type,
      };
      if (onSearchText !== "") {
        params.search = onSearchText;
      }

      GET(`${routePath}`, params, true)
        .then(({ data }) => {
          setData([...data]);

        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [onSearchText, timeNow, filter]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setSearchText("");
    setTimeNow(moment().valueOf());
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const { name, type, group } = getValues();

    const formData = {
      name,
      type,
      group,
    };

    const request = editId
      ? PUT(`${routePath}/${editId}`, formData, {}, true)
      : POST(`${routePath}`, formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
    reset(DEFAULT_CATEGORY);
    setEditedId();
  };

  // function that loads the want to editted data
  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`${routePath}/${id}`, {}, true)
      .then(({ data }) => {
        reset(data);
        setView({ add: false, edit: true });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }

    DELETE(`${routePath}/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa danh mục thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý danh mục"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Danh mục</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          placeholder="Tìm kiếm danh mục"
                          className="form-control  border-primary"
                          value={onSearchText}
                          onChange={(e) => onFilterChange(e)}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          classNamePrefix="form-control"
                          placeholder="Lọc theo nhóm"
                          options={CATEGORY_GROUP_OPTIONS}
                          value={CATEGORY_GROUP_OPTIONS.find(
                            (c) => c.value === filter.group
                          )}
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              group: val?.value || undefined
                            });
                          }}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          classNamePrefix="form-control"
                          placeholder="Lọc theo loại"
                          options={CATEGORY_TYPE_OPTIONS}
                          value={CATEGORY_TYPE_OPTIONS.find(
                            (c) => c.value === filter.type
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              type: val?.value || undefined
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm danh mục</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        >
                          {/* <label>
                            <span className="d-none d-sm-inline-block">Show</span>
                            <Input type="month" />
                          </label> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Thêm danh mục</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Tên danh mục <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="name"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Nhóm <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="group"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={CATEGORY_GROUP_OPTIONS}
                                value={CATEGORY_GROUP_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => {
                                  onChange(val.value)
                                  if (listOnlyhaveTypeOut.includes(val.value)) {
                                    setValue('type', 'OUT')
                                  }
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="group"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12" className={listOnlyhaveTypeOut.includes(group) ? 'd-none' : ''}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Loại <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="type"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={CATEGORY_TYPE_OPTIONS}
                                value={CATEGORY_TYPE_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => onChange(val.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="type"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="plus"></Icon>
                        <span>{!!editId ? 'Sửa ' : 'Thêm'} danh mục</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá danh mục này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default PNCategoryManager;
